import { useScrollToTop } from "core/hooks/useScrollToTop";
import AppLayout from "core/layouts/AppLayout";
import BottomNavigation from "core/layouts/BottomNavigation";
import PageHeader from "core/components/Header/PageHeader";
import { _t } from "core/language";
import { useRecipe } from "./../hooks/recipe";
import FlavorList from "./../components/Flavor/List";
import FlavorListLoading from "./../components/Flavor/Loading";
import { useFetchFlavors } from './../hooks/flavor';

const FlavorsPage = () => {
  const { resetRecipes } = useRecipe()
  const { loading, data } = useFetchFlavors()
  useScrollToTop()

  return (
    <AppLayout>
      <PageHeader
        title={_t('ingredient.option.title')}
        sticky
      />
      {(!data.length && loading) ? (
        <div className="px-4">
          {Array.from(Array(6).keys()).map((e: number) => 
            <FlavorListLoading key={e} />
          )}
        </div>
      ) : null}
      <div className="bg-[#f4f4f4] h-[6px] w-full"></div>
      <FlavorList flavors={data} />
      <BottomNavigation
        onNavigateChange={resetRecipes}
        activeIndex={2}
      />
    </AppLayout>
  );
};

export default FlavorsPage;
